import { render, staticRenderFns } from "./activity-session-game-table.vue?vue&type=template&id=56a69c7e&scoped=true&"
import script from "./activity-session-game-table.vue?vue&type=script&lang=ts&"
export * from "./activity-session-game-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a69c7e",
  null
  
)

export default component.exports